import Slider from './slider';

const nav = {
  init() {
    new Slider('.js-nav', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
    }, true);
  },
};

export default nav;



// WEBPACK FOOTER //
// ./scripts/modules/nav.js